import { BookOpen, Globe, Image as ImageIcon } from "lucide-react";
import type { ListingChangePayload } from "@colab/shared";
import { cn } from "@/lib/utils";

// Marketplace-tile-style preview driven by the CURRENT form values (the
// page streams them in via ListingForm's onChange). Purely presentational —
// no fetching, no state — and compact enough to sit in the side column next
// to the form. Empty fields render muted placeholders instead of collapsing
// so the tile keeps its shape while the partner types.
export function ListingPreviewCard({ payload }: { payload: ListingChangePayload }) {
  return (
    <div className="overflow-hidden rounded-xl border bg-card shadow-sm">
      {payload.hero_image_url ? (
        <img
          src={payload.hero_image_url}
          alt=""
          className="h-36 w-full border-b object-cover"
        />
      ) : (
        <div className="flex h-36 w-full items-center justify-center border-b bg-muted/40">
          <ImageIcon className="h-5 w-5 text-muted-foreground/50" />
        </div>
      )}

      <div className="p-4">
        <div className="flex items-center gap-3">
          {payload.logo_url ? (
            <img
              src={payload.logo_url}
              alt=""
              className="h-9 w-9 shrink-0 rounded-md border bg-background object-contain p-1"
            />
          ) : (
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border bg-muted/40">
              <ImageIcon className="h-3.5 w-3.5 text-muted-foreground/50" />
            </div>
          )}
          <p
            className={cn(
              "truncate font-display text-sm font-semibold tracking-tight",
              !payload.name && "text-muted-foreground/60",
            )}
          >
            {payload.name || "Listing name"}
          </p>
        </div>

        <p
          className={cn(
            "mt-2 line-clamp-3 text-xs text-muted-foreground",
            !payload.short_description && "italic text-muted-foreground/60",
          )}
        >
          {payload.short_description || "Your short description appears here."}
        </p>

        {payload.website_url || payload.documentation_url ? (
          <div className="mt-3 flex flex-wrap items-center gap-3 border-t pt-3">
            {payload.website_url ? (
              <a
                href={payload.website_url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground hover:text-foreground"
              >
                <Globe className="h-3 w-3" />
                Visit website
              </a>
            ) : null}
            {payload.documentation_url ? (
              <a
                href={payload.documentation_url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground hover:text-foreground"
              >
                <BookOpen className="h-3 w-3" />
                Docs
              </a>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
